export default __webpack_public_path__ + "static/media/Saved_Search.9a91e570.svg";